import React from 'react';
import { OptionsColorPicker } from '../../primitives';
import { TAG_COLORS_VALUES } from '../types';
import { tagColorCssVar } from './CRMStyles';

interface Props {
  value: string | undefined | null;
  update: (v: string | undefined | null) => void; 
}

export const TagColorPicker = (props: Props) => {
  return (
    <OptionsColorPicker
      value={props.value}
      update={v => props.update(v)}
      options={TAG_COLORS_VALUES}
      transformColor={c => `var(${tagColorCssVar(c || "unknown")})`}
      />
  );
}
